import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { uamApi } from "@/api/uamApi";
import { REM_CONFIG } from "@/utils/fontSize";
const InboundOutboundStatus = ({ className = "", }) => {
    const chartRef = useRef(null);
    const [selectedTime, setSelectedTime] = useState("2025-09"); // 动态时间维度
    const [chartData, setChartData] = useState([]);
    const subsystemLabels = chartData.map((item) => item.subsystemLabel) || [];
    const inbound = chartData.map((item) => item.inboundCount) || [];
    const outbound = chartData.map((item) => item.outboundCount) || [];
    // 初始化数据 & 响应式适配
    useEffect(() => {
        getData();
        // const handleResize = () => {
        //   const chartInstance = chartRef.current?.getEchartsInstance();
        //   if (!chartInstance) return;
        //   chartInstance.setOption(getChartOption());
        // };
    }, [selectedTime]);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await uamApi.inout();
            if (res.data) {
                setChartData(res.data);
            }
        }
        catch (e) { }
    };
    // ECharts配置项（横向条形图适配）
    const getChartOption = () => ({
        title: { show: false }, // 隐藏标题，设计图无额外标题
        legend: {
            data: ["入库", "出库"], // 匹配设计图图例
            right: "center",
            top: 8,
            textStyle: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            itemGap: 30,
            itemWidth: 16,
            itemHeight: 8,
            icon: "rect",
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        grid: {
            left: "4%", // 预留空间显示Y轴分类名
            right: "4%",
            bottom: "0%",
            top: 30,
            containLabel: true,
        },
        // 在右上角添加单位显示
        graphic: {
            type: "text",
            right: 10,
            top: 15,
            style: {
                text: "单位：项",
                fill: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                fontFamily: "Arial, sans-serif",
            },
        },
        yAxis: {
            type: "category",
            data: subsystemLabels, // Y轴显示分类
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            axisLine: { lineStyle: { color: "rgba(455,255,255,0.2)" } },
        },
        xAxis: {
            show: false,
            type: "value",
            nameTextStyle: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                padding: [30, 0, 0, 0],
            }, // 调整名称位置
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
            splitLine: { show: true, lineStyle: { color: "rgba(255,255,255,0.1)" } },
        },
        series: [
            {
                name: "入库",
                type: "bar",
                data: inbound,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        // 横向渐变（从左到右）
                        { offset: 0, color: "#2F96E2" },
                        { offset: 1, color: "#1572C4" },
                    ]),
                    barBorderRadius: [0, 8, 8, 0], // 四角圆角
                },
                barWidth: "20%",
                barGap: "40%",
                label: {
                    // 显示数值标签
                    show: true,
                    position: "right",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
            },
            {
                name: "出库",
                type: "bar",
                data: outbound,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                        // 横向渐变（从左到右）
                        { offset: 0, color: "#60FFFF" },
                        { offset: 1, color: "#40C0FF" },
                    ]),
                    barBorderRadius: [0, 8, 8, 0],
                },
                barWidth: "20%",
                barGap: "40%",
                label: {
                    show: true,
                    position: "right",
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
            },
        ],
    });
    return (_jsxs("div", { className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.5)]
        backdrop-blur-sm
        flex flex-col
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u51FA\u5165\u5E93\u60C5\u51B5" }), " ", _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { ref: chartRef, option: getChartOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) })] }));
};
export default InboundOutboundStatus;
